import { Router, Redirect } from "@gatsbyjs/reach-router";
import React from "react";

import CGIGRP2LoginDialogOther from "./CGIGRP2LoginDialogOther";
import CGIGRP2LoginDialogSame from "./CGIGRP2LoginDialogSame";

export default function CGIGRP2LoginDialogRouter() {
  // Predict option based on device orientation. There’s probably better ways to do it…
  let predictedOption =
    typeof window !== "undefined" &&
    window.matchMedia("(orientation: portrait)").matches
      ? "same"
      : "other";

  return (
    <Router>
      <Redirect from="/" to={predictedOption} noThrow={true} />
      <CGIGRP2LoginDialogSame path="same" />
      <CGIGRP2LoginDialogOther path="other" />
    </Router>
  );
}
